function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M56.806 19.63h-5.688a22.268 22.268 0 00-6.293-12.455A22.246 22.246 0 0029.005.619c-3.495 0-6.98.828-10.102 2.404a.806.806 0 00-.414.495.81.81 0 00.07.646l3.536 6.365a.823.823 0 001.081.343 13.508 13.508 0 015.819-1.323 13.35 13.35 0 019.506 3.94 13.428 13.428 0 013.505 6.132h-5c-1.071 0-1.455.727-.839 1.606l9.617 13.84c.617.879 1.617.879 2.233 0l9.627-13.84c.617-.869.243-1.596-.838-1.596zM35.915 35.46a.823.823 0 00-1.081-.343 13.508 13.508 0 01-5.819 1.324 13.35 13.35 0 01-9.506-3.94 13.428 13.428 0 01-3.505-6.132h5c1.07 0 1.455-.727.839-1.606l-9.628-13.84c-.616-.879-1.616-.879-2.232 0L.355 24.763c-.616.879-.232 1.606.839 1.606H6.88a22.269 22.269 0 006.294 12.456 22.247 22.247 0 0015.82 6.556c3.495 0 6.98-.828 10.102-2.404a.806.806 0 00.414-.495.81.81 0 00-.07-.647l-3.526-6.374z",
  fill: "#F5F1E3"
});

var SvgCycle = function SvgCycle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 58 46",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCycle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cycle.1bf6fa75.svg";
export { ForwardRef as ReactComponent };